import React, { FormEvent, useState, useEffect, useRef } from "react";
import styles from "./SearchPopupLocal.module.scss";
import { ResetButton } from "components/buttons/resetButton/ResetButton";
import { getAllClassNames, setParams } from "helpers";
import { Close, Search } from "assets/icons";
import Button from "components/buttons/button/Button";
import strings from "assets/strings";
import { grad1, grad2, SERACH_DOCTORS_API } from "assets/constants";
import { settings } from "assets/settings";
import Popup from "../Popup";
import { AlertPopup } from "../alertPopup/AlertPopup";
import { KeyValuePair } from "types";
import { Loader } from "assets/images";


export type ISearchPopup = {
  title: string;
  subTitle?: string;
  placeholder?: string;
  attributeLocal?: string;
  serviceType?: string;
  queryParams?: KeyValuePair[];
  popupBubbles?: { value: string; label: string; }[];
  keyToNormalize: string;
  labelToNormalize: string;
  //filterBy,
  onSubmit: (a: { value: string; label: string; }[], params: string) => void;
  setOldBubbles: () => void
};


export const SearchPopupLocal = ({
  title,
  subTitle,
  placeholder,
  attributeLocal,
  serviceType,
  queryParams,
  popupBubbles,
  keyToNormalize,
  setOldBubbles,
  labelToNormalize,
  //filterBy,
  onSubmit,
}: ISearchPopup) => {
  const [selectOptions, setSelectOptions] = useState<Array<{ value: string; label: string; }>>([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [bubbles, setBubbles] = useState<Array<{ value: string; label: string; isSubField: false }>>(popupBubbles as any[]);
  const [multiSelectParams, setMultiSelectParams] = useState<string[]>([]);
  const popupRef = useRef<HTMLDivElement>(null);

  const openerRef = useRef<HTMLButtonElement>(null);
  const isSelected = (value: any): boolean => {
    const values = bubbles.map(item => item.label);
    return values.includes(value.label);
  }

  const handleToggleVisibility = () => {
    if (popupRef.current) {
      popupRef.current.classList.toggle('show');
    }
  };


  const handleCloseKeyDown = (event: React.KeyboardEvent<SVGSVGElement>, item: { value: string; label: string; hasSubField?: boolean }) => {
    if (event.key === "Enter") {
      onSelect(item);
    }
  };

  const onSelect = (item: any) => {
    const temp = [...bubbles];
    const index = temp.findIndex((bubble) => bubble.label === item.label);
    if (index !== -1) temp.splice(index, 1);
    else temp.push(item);
    setBubbles(temp);
    const tempParams = [...multiSelectParams];
    const indexParam = temp.findIndex((bubble) => bubble === item.value);
    if (indexParam !== -1) tempParams.splice(indexParam, 1);
    else tempParams.push(item.value)
    setMultiSelectParams(tempParams);
    setQuery("");
  };

  const onReset = () => {
    setOldBubbles();
    setBubbles([]);
    setQuery("");
  };

  const onContinue = () => {
    // if (bubbles.length === 0) {
    //   handleToggleVisibility();
    //   return;
    // }
    onSubmit(bubbles, multiSelectParams.join(','));
  };

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleReset = (event: FormEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setQuery("");
  };

  useEffect(() => {
    const fetchOptions = async () => {
      setLoading(true);
      const response = await fetch(`https://${settings.searchApiUrl}${SERACH_DOCTORS_API}${serviceType ? `${serviceType}` : ''}${attributeLocal}?${setParams(queryParams)}`);
      const options: any[] = await response.json();
      if (options.length) {
        setLoading(false);
        localStorage.setItem(`${attributeLocal}`, JSON.stringify(options));
        const normalizedOptions = options.map(item => {
          return {
            value: item[keyToNormalize],
            label: item[labelToNormalize],
          };
        });        
        setSelectOptions(normalizedOptions);       
      }
    }
    fetchOptions();
  }, [])

  return (
    <div className={getAllClassNames([styles.container])}>
      <h3 className={styles.title}>{title}</h3>
      {subTitle && <p className={styles.subTitle}>{subTitle}</p>}
      <form
        action=""
        className={getAllClassNames(["ais-SearchBox-form", styles.form])}
        noValidate
        onSubmit={handleSubmit}
        onReset={handleReset}
      >
        <input
          aria-autocomplete="list" role="combobox" //aria-owns="divList"  aria-activedescendant="divList"
          className="ais-SearchBox-input"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          placeholder={placeholder}
          spellCheck={false}
          maxLength={35}
          type="search"
          value={query}
          onChange={(e: any) => setQuery(e.target.value)}
        />
        {!query && <Search className={styles.searchIcon} />}
        <ResetButton hidden={query === undefined || query.length === 0} />
      </form>

      {loading && <div className={styles.popup}><img src={Loader} /></div>}
      <div className={styles.divList}>
        {bubbles.length > 0 && (
          <div className={styles.divBubbles}>
            {bubbles.map((item) => (
              <div key={item.value} className={styles.bubble}>
                <span className={styles.labelText}>{item.label}</span>
                <Close
                  aria-label={`${strings.globalStrings.remove} ${item.label}`} // Added aria-label for accessibility
                  onClick={() => onSelect(item)}
                  className={styles.closeIcon}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(event) => handleCloseKeyDown(event, item)}
                />
              </div>
            ))}
          </div>
        )}
        <div className={styles.list} id="divList">
        {selectOptions.filter((item) => item.label?.includes(query)).length === 0 && query.length > 0 && (
            <div className={styles.noResults}>אין תוצאות</div>
          )}

          {selectOptions
            .filter((item) => item.label?.includes(query))
            .map((item) => (
              <label
                key={item.label}
                className={getAllClassNames([
                  "ais-RefinementList-label",
                  isSelected(item) && "ais-RefinementList-item--selected",
                  styles.label,
                ])}
              >
                <input
                  className={getAllClassNames([
                    "ais-RefinementList-checkbox",
                    styles.checkbox,
                  ])}
                  type="checkbox"
                  value={item.value}
                  checked={isSelected(item)}
                  onChange={() => onSelect(item)}
                />
                <span
                  className={getAllClassNames([
                    "ais-RefinementList-labelText",
                    styles.labelText,
                  ])}
                >
                  {item.label}
                </span>
              </label>
            ))}

        </div>
      </div>
      <div className={styles.viewBottom}>
        <Button
          onClick={onReset}
          replaceClassName={styles.buttonClear}
          text={strings.globalStrings.clear}
        />
        <Button
          ref={openerRef}
          onClick={onContinue}
          color1={grad1}
          color2={grad2}
          replaceClassName={styles.buttonContinue}
          text={strings.globalStrings.continue}
        />
      </div>
        <Popup
          ref={popupRef}
          hideBackdrop
          onClose={() => handleToggleVisibility()}
          height={284}
          width={450}
          //style={{ paddingBottom: '0px' }}
        >
          <AlertPopup
            title={strings.errorMessages.notice}
            subTitle={strings.globalStrings.selectItemFromList}
            showButton
            buttonText={strings.globalStrings.close}
            onClose={() => handleToggleVisibility()}
          ></AlertPopup>
        </Popup>
    </div>
  );
};
